module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_56-87e0dd4d244f229132c444e7b9fccac8.png";